import { Navigate, Outlet } from "react-router-dom";
import { useAutistaAuth } from "../context/AutistaAuthContext";
import { Loader2 } from "lucide-react";

export default function AutistaLayout() {
  const { token, loading } = useAutistaAuth();

  if (loading) {
    return (
      <div className="flex min-h-[100dvh] items-center justify-center bg-slate-50 dark:bg-[#18181f]" role="status" aria-label="Caricamento">
        <Loader2 className="w-8 h-8 animate-spin text-indigo-500" />
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/autista-login" replace />;
  }

  return <Outlet />;
}
